const setHrefTarget = (link: string) => {
  const linkUrl = new URL(link);
  const linkHost = linkUrl.hostname;
  const linkPort = linkUrl.port;
  const appHost = window.location.host;
  const linkBasePath = linkUrl.port ? `${linkHost}:${linkPort}` : linkHost;

  return linkBasePath === appHost ? "_self" : "_blank";
};

export default setHrefTarget;
